import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../api';

/**
 * Tela aberta pelo link do email de recuperação (`/recuperar-senha?token=...`).
 * Email é obrigatório só para validar que quem abre o link é o dono da conta.
 */
export default function RecuperarSenha() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';

  const [email, setEmail] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);
  const [sucesso, setSucesso] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');

    if (!token) {
      setErro('Link inválido. Solicite uma nova recuperação de senha.');
      return;
    }
    if (!email.trim()) {
      setErro('Informe o email da conta.');
      return;
    }
    if (novaSenha.length < 6) {
      setErro('A senha deve ter no mínimo 6 caracteres.');
      return;
    }
    if (novaSenha !== confirmar) {
      setErro('As senhas não coincidem.');
      return;
    }

    setLoading(true);
    try {
      await api.redefinirSenha(token, email.trim(), novaSenha);
      setSucesso(true);
    } catch (err) {
      setErro(err.message || 'Não foi possível redefinir a senha. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="login-logo">
          <span className="marca-icone marca-icone--md" aria-hidden="true">
            <img src={process.env.PUBLIC_URL + '/icone-sem-fundo.png'} alt="" />
          </span>
          <div>
            <div className="login-logo-title">AgriGest</div>
            <div className="login-logo-sub">Gestão Agrícola</div>
          </div>
        </div>

        {sucesso ? (
          <div>
            <div className="msg msg-success">
              Senha redefinida com sucesso. Faça login com a nova senha.
            </div>
            <button type="button" className="btn-primary botao-largo" onClick={() => navigate('/login')}>
              Ir para o login
            </button>
          </div>
        ) : (
          <>
            <div className="login-titulo-bloco">
              <div className="login-titulo">Nova senha</div>
              <p>
                Confirme o email da conta e escolha uma nova senha (mínimo 6 caracteres).
                O link vale por 1 hora e só pode ser usado uma vez.
              </p>
            </div>

            {!token && (
              <div className="msg msg-error">
                Link inválido ou incompleto. Volte ao login e use &quot;Esqueci minha senha&quot; para receber um novo link.
              </div>
            )}
            {erro && <div className="msg msg-error">{erro}</div>}

            <form onSubmit={handleSubmit} autoComplete="on">
              <div className="login-field">
                <label htmlFor="recuperar-email">Email da conta</label>
                <input
                  id="recuperar-email"
                  type="email"
                  name="email"
                  autoComplete="username"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="seuemail@exemplo.com"
                  autoFocus
                  disabled={!token}
                />
              </div>
              <div className="login-field">
                <label htmlFor="nova-senha">Nova senha</label>
                <input
                  id="nova-senha"
                  type="password"
                  name="new-password"
                  autoComplete="new-password"
                  value={novaSenha}
                  onChange={(e) => setNovaSenha(e.target.value)}
                  required
                  minLength={6}
                  disabled={!token}
                />
              </div>
              <div className="login-field--ultimo">
                <label htmlFor="confirmar-senha">Confirmar senha</label>
                <input
                  id="confirmar-senha"
                  type="password"
                  name="confirm-password"
                  autoComplete="new-password"
                  value={confirmar}
                  onChange={(e) => setConfirmar(e.target.value)}
                  required
                  minLength={6}
                  disabled={!token}
                />
              </div>
              <button type="submit" className="btn-primary botao-largo" disabled={loading || !token}>
                {loading ? 'Salvando...' : 'Redefinir senha'}
              </button>
            </form>

            <p className="login-voltar">
              <Link to="/login" className="login-voltar">Voltar ao login</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
